const Gnosis = () => (
  <svg fill='#fff' viewBox='0 0 24 24'>
    <path d='M7.054 13.665c.69 0 1.363-.23 1.907-.65L4.587 8.64a3.124 3.124 0 0 0 .56 4.38c.55.414 1.218.644 1.907.644Zm13.009-3.123c0-.69-.23-1.363-.65-1.906l-4.374 4.373a3.117 3.117 0 0 0 5.024-2.467Z' />
    <path d='m22.267 5.781-1.934 1.935a4.409 4.409 0 0 1-.555 6.207 4.405 4.405 0 0 1-5.653 0L12 16.05l-2.12-2.12a4.409 4.409 0 0 1-6.207-.555 4.405 4.405 0 0 1 0-5.653L2.68 6.73l-.942-.948A11.976 11.976 0 0 0 0 12c0 6.628 5.372 12 12 12s12-5.372 12-12c.006-2.193-.6-4.346-1.733-6.219Z' />
    <path d='M20.68 3.718C16.11-1.077 8.518-1.256 3.723 3.314A12.722 12.722 0 0 0 2.478 4.7L12 14.226 21.521 4.7a11.588 11.588 0 0 0-.84-.981ZM12 1.57c2.804 0 5.417 1.082 7.38 3.056L12 12.006l-7.38-7.38A10.318 10.318 0 0 1 12 1.57Z' />
  </svg>
)

export { Gnosis }
